<div>
	<div class="modal-header">
		<h3 id="modal-title">
			@if(isVideoSource) {
				{{ 'Event_ScheduledEventsForVideoSource' | translate : { '0': videoSourceDisplayName, '1': videoSourceName} }}
			}
			@else {
				{{ 'Event_ScheduledEventsForShortcut' | translate : { '0': '24' } }}
			}
		</h3>
		<div [hidden]="!eventUrl">{{eventUrl}}</div>
		<p class="padding-top-10" [hidden]="!reservationDate">{{ reservationDate | vbDateTimeMedium }}</p>
	</div>

	<div class="modal-body">
		<div class="scrolly-mode-modal">
			<div *ngFor="let event of events">
				<div [ngClass]="[
					isSelectedResource && event.conflict ? 'conflicted-bg' : '',
					!isSelectedResource && event.conflict ? 'reservations-bg' : ''
				]">
					<p class="header-type21 type-bold padding-top-10">
						<span class="glyphicons circle_exclamation_mark xtra-space-right" [hidden]="!isSelectedResource || !event.conflict"></span>
						{{event.title}}
					</p>
					<p>{{ 'Event_Date' | translate }}: {{event.startDate | vbDateTimeMedium }} - {{event.endDate | vbDateTimeMedium }}</p>
					<p>
						{{ 'Event_EventAdmin' | translate }}:
						<span *ngIf="isVideoSource">{{event.eventAdminFirstName}} {{event.eventAdminLastName}}</span>
						<span *ngIf="!isVideoSource">{{formatHostNames(event.eventHostNames)}}</span>
					</p>
				</div>
				<hr/>
			</div>
		</div>
	</div>
	<div class="modal-footer">
		<button type="button" (click)="close()" vbBtnWhite>{{ 'Close' | translate }}</button>
	</div>
</div>
